import { ERROR, FLUSH, MESSAGE, ADD_ENDROSMENT, ENDROSMENT_LIST } from './constants';

const initialState = {
  error: null,
  list: [],
  message: null
};

export default function reducer (state = initialState, action) {
  switch (action.type) {
    
    case ERROR:
      return {
        ...state,
        error: action.error
      };

    case ENDROSMENT_LIST:
      return {
        ...state,
        list: action.result
      };

    case FLUSH:
      return {
        ...initialState
      };

    case MESSAGE:
      return {
        ...state,
        message: action.message
      };

    case ADD_ENDROSMENT:
      return {
        ...state,
        list: action.result
      };

    default: 
      return {
        ...state
      }
  }
}
